import { useEffect, useState } from "react";
import {
    Button, Input, ModalHeader, Modal, ModalFooter, Col, Row
} from 'reactstrap';
import { useDispatch, useSelector } from "react-redux";
import { addEmailPrompt, updateEmailPrompt } from "../../usersettings/apiclient";
import { updateOffsetLimitValue } from "../../../redux/features/settings/settingslice";
const EmailPromptModal = (props) => {

    const dispatch = useDispatch();
    const userId = useSelector((state) => state.user.user.user_id);
    const [title, setTitle] = useState('');
    const [prompt, setPrompt] = useState('');
    const [titleError, setTitleError] = useState('');
    const [promptError, setPromptError] = useState('');

    useEffect(() => {
        if (props?.isEditPrompt) {
            handleEdit(props?.promptDetails)
        } else {
            resetInput()
        }
    }, [props])

    const toggleModal = () => {
        resetInput()
        props.toggleModal()
    }
    const resetInput = () => {
        setTitle('');
        setPrompt('');
    }

    const handleEdit = (details) => {
        setTitle(details?.title || '');
        setPrompt(details?.text || '');
    }

    const handleInputChange = (event) => {
        if (event.target.name === 'title') {
            setTitle(event.target.value)
            setTimeout(() => {
                formValidation()
            }, 100);
        } else {
            setPrompt(event.target.value)
            setTimeout(() => {
                formValidation()
            }, 100);
        }
    }

    const formValidation = () => {
        let isValidate = true;
        if (title.trim().length === 0 || title.trim() === "") {
            isValidate = false;
            setTitleError("This field is required")
        }
        else {
            setTitleError("")
        }
        if (prompt.trim().length === 0 || prompt.trim() === "") {
            isValidate = false;
            setPromptError("This field is required")
        } else {
            setPromptError("")
        }
        return isValidate;
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (formValidation()) {
            const promptDetails = {
                title,
                text: prompt
            }
            dispatch(updateOffsetLimitValue({ offset: 0, limit: 50 }))
            if (props?.isEditPrompt) {
                updateEmailPrompt(dispatch, promptDetails, props?.promptDetails.prompt_id, userId)
            } else {
                promptDetails.is_default = false
                addEmailPrompt(dispatch, promptDetails, userId)
            }
            toggleModal()
        }
    }

    return (
        <Modal isOpen={props.isOpen} toggle={() => toggleModal()} id="addEeventsModal">
            <ModalHeader className="blueHeaderBg mb-3">
                {props?.isEditPrompt ? "Edit prompt" : "Create prompt"}
                <button type="button" className="close" aria-label="Close" onClick={() => { toggleModal() }}><span aria-hidden="true">×</span></button>
            </ModalHeader>
            <div className="emailFormCnt">
                <form>
                    <div className="event-form">
                        <Row className="mb-3">
                            <Col className="event-input mb-3" md="12">
                                <label>Title</label>
                                <Input type="text" value={title} name="title" onChange={handleInputChange} maxLength={50}/>
                                {titleError ? <p className="error-text">{titleError}</p> : ""}
                            </Col>
                        </Row>
                        <Row className="mb-3">
                            <Col className="event-input mb-3" md="12">
                                <label>Prompt</label>
                                <p>Write a prompt below to guide the creation of your emails. Include key information about your company, such as areas of expertise, unique selling points, specialised skills, notable projects, or awards. This ensures the generated messages accurately represent your brand and engage your recipients.</p>
                                <Input type="textarea" value={prompt} name="prompt" rows={10} onChange={handleInputChange} />
                                {promptError ? <p className="error-text">{promptError}</p> : ""}
                            </Col>
                        </Row>
                    </div>
                </form>
            </div>
            <ModalFooter className="d-flex justify-content-between">
                <div className="d-inline-flex justify-content-start">
                    <Button id="primaryBtn" className="primary-btn btn-save-cancel me-3" type="submit" autoFocus={true} onClick={(e) => handleSubmit(e)}>Save</Button>
                    <Button className="outline-btn btn-save-cancel" onClick={() => { toggleModal() }}>Cancel</Button>
                </div>
            </ModalFooter>
        </Modal>
    )
}
export default EmailPromptModal;
